import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import MessageContainer from './MessageContainer';
import TransferInfo from './TransferInfo';
import axios from '../../../axios/axios';
import Captcha from '../captcha/Captcha';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class TransferState extends Component {
    constructor(props) {
        super(props);
        this.props = props

        this.state = {
            transferNumber: '',
            message: '',
            showMessage: false,
            isValidNumber: true,
            isButtonDisabled: true,
            isShowCaptcha: false,
            isCaptchaValid: false,
            isResetCaptcha: false,
        }

        this.transferInfoRef = React.createRef();
    }

    componentDidMount() {
        this.scrollToGetTransferInfo();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.key !== prevProps.location.key && this.props.location.hash === '#getTransferInfo') {
            window.scrollTo(0, this.transferInfoRef.current.offsetTop);
        }
      }

    scrollToGetTransferInfo = () => {
        if (this.props.location.state && this.props.location.state.getTransferInfo) {
            window.scrollTo(0, this.transferInfoRef.current.offsetTop);
        }
    }

    getStatus() {
        const staticWainingMessage = translateStaticContent('transferInfoWaitingMessage', 
                        this.props.defaultStaticContentTransferInfo, this.props.activeLangStaticContentTransferInfo);
        this.setState({...this.state,
            showMessage: true,
            isCaptchaValid: true,
            isShowCaptcha: true,
            message: staticWainingMessage,
        });

        axios.defaults.headers.isocode = this.props.activeLang ? this.props.activeLang : 'uk';
        axios.get(`/api/welsend/public/transfers/${this.state.transferNumber}`)
        .then(response => {
            if (response.status === 200) {
                this.setState({...this.state,
                    showMessage: true,
                    isValidNumber: true,
                    message: response.data.text,
                })
            }
        })
        .catch((error =>  {
              console.log(error.response.data);
              this.setState({...this.state,
                showMessage: true,
                isValidNumber: false,
                message: error.response.data.text
            })
        }))
    }

    onChangeHandler = (e) => {
        let { value, max } = e.target;
        let transferNumber = value.replace(/\D/g,'').slice(0, max);
        const staticWarningMessage = translateStaticContent('transferInfoWarningMessage', 
                        this.props.defaultStaticContentTransferInfo, this.props.activeLangStaticContentTransferInfo);           
        if (transferNumber.length === 10) {
            this.setState({...this.state,
                isButtonDisabled: true,
                transferNumber: transferNumber,
                isShowCaptcha: false,
                isValidNumber: true,
                showMessage: true,
                isCaptchaValid: false,
                isResetCaptcha: false,
                message: staticWarningMessage,
            }, () => {this.setState({...this.state,
                isButtonDisabled: false,
                transferNumber: transferNumber,
                isValidNumber: true,
                showMessage: false,
                isResetCaptcha: true,
                isCaptchaValid: false,
            })})
            } else if (transferNumber.length >= 0 && transferNumber.length < 10) {
            this.setState({...this.state,
                isButtonDisabled: true,
                transferNumber: transferNumber,
                isShowCaptcha: false,
                isValidNumber: true,
                showMessage: true,
                isCaptchaValid: false,
                isResetCaptcha: false,
                message: staticWarningMessage,
            });
        } 
        else {
            this.setState({...this.state, message: '', showMessage: false, transferNumber: transferNumber});
        }                        
    }

    handleCheckStatus = () => {
        this.setState({...this.state, isShowCaptcha: true});
        if (this.state.isCaptchaValid) {
            this.getStatus();
        }
    }

    submitData = (result) => {
        if (result) {
            this.getStatus();
        }
    }

    render() {
        const isButtonDisabled = this.state.isButtonDisabled ? 'disabled' : '';
        const isShowCaptcha = this.state.isShowCaptcha ? 'show' : '';
        return (
            <div className="container transferState">
               <h1>
                    {translateStaticContent('transferInfoHeading', 
                        this.props.defaultStaticContentTransferInfo, this.props.activeLangStaticContentTransferInfo)}
               </h1>
                <div className="status-field">
                    <input type="text" id='statusNumber' max='10'
                        value={this.state.transferNumber}
                        onChange={this.onChangeHandler} />
                    <label htmlFor="statusNumber"></label>
                    <button className={`${isButtonDisabled} btn`} 
                            disabled={this.state.isButtonDisabled}
                            onClick={this.handleCheckStatus}
                    >
                        {translateStaticContent('transferInfoBtn', 
                            this.props.defaultStaticContentTransferInfo, this.props.activeLangStaticContentTransferInfo)}
                    </button>
                    <div className={`captcha-block ${isShowCaptcha}`}>
                        <Captcha submitData={this.submitData} reset={this.state.isResetCaptcha}/>
                    </div>
                </div>
                    <MessageContainer message={this.state.message} 
                        isValidNumber={this.state.isValidNumber}
                        showMessage={this.state.showMessage} />
                <div ref={this.transferInfoRef}>
                    <TransferInfo defaultStaticContentTransferState={this.props.defaultStaticContentTransferState}
                                  activeLangStaticContentTransferState={this.props.activeLangStaticContentTransferState}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    activeLang: state.lang.activeLang
})

export default connect(mapStateToProps)(TransferState);

TransferState.propTypes = {
    location: PropTypes.object.isRequired,
    activeLang: PropTypes.string.isRequired,
    defaultStaticContentTransferInfo: PropTypes.object,
    activeLangStaticContentTransferInfo: PropTypes.object,
    defaultStaticContentTransferState: PropTypes.object,
    activeLangStaticContentTransferState: PropTypes.object,
}